module.exports = __webpack_public_path__ + "bc.no2.3aec6c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bc.no2.jpg
// module id = ha3S
// module chunks = 0